import './CommpanyPage.css';

function CommpanyPage(){
  return (
    <div className="CommpanyPage">
        <div className="black-background">
            <span className="white-text">会社概要</span>
        </div>
        <div className="container">
            <div className="section">
                <span className="culm-text">会社名</span>
                <span className="culm-detail">株式会社高橋機工</span>
            </div>
            <hr />
            <div className="section">
                <span className="culm-text">所在地</span>
                <span className="culm-detail">宮城県塩竈市新浜町1丁目26-15</span>
            </div>
            <hr />
            <div className="section">
                <span className="culm-text">代表取締役</span>
                <span className="culm-detail">高橋 孝</span>
            </div>
            <hr />
            <div className="section">
                <span className="culm-text">設立日</span>
                <span className="culm-detail">2013年6月1日</span>
            </div>
            <hr />
            <div className="section">
                <span className="culm-text">資本金</span>
                <span className="culm-detail">500万円</span>
            </div>
            <hr className="last" />
        </div>
    </div>
  );
};

export default CommpanyPage;